import { useChatSidebarSyncRouteState } from '@ui/features/mildang-ai/stores/chatStore';
import { Suspense } from 'react';

function ChatSidebarSyncRouteStateInner() {
  useChatSidebarSyncRouteState();
  return null;
}

export function ChatSidebarSyncRouteState() {
  return (
    <Suspense fallback={null}>
      <ChatSidebarSyncRouteStateInner />
    </Suspense>
  );
}
